import React, { type JSX } from 'react';
import { type GetStaticPaths, type GetStaticProps } from 'next';
import getBuildsClassesAndSpecsPageViewModels from '../../../../helpers/getBuildsClassesAndSpecsPageViewModels';
import getGameSlugs from '../../../../helpers/getGameSlugs';
import ClassesAndSpecsPage, {
  type ClassesAndSpecsPageProps,
} from '../../../../components/ClassesAndSpecsPage/ClassesAndSpecsPage';
import { initRequest } from '../../../../helpers/rpgLogsApiRequestMetadata';

export const BuildsClassesAndSpecsPagePath =
  '/[gameSlug]/builds/classes-and-specs';

export default function BuildsClassesAndSpecsPage(
  props: ClassesAndSpecsPageProps,
): JSX.Element {
  return <ClassesAndSpecsPage {...props} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
  const gameSlugs = await getGameSlugs();

  return {
    paths: gameSlugs.map((gameSlug) => ({
      params: {
        gameSlug,
      },
    })),
    fallback: 'blocking',
  };
};

const thirteenHours = 13 * 60 * 60;
export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (!params?.gameSlug || !(typeof params.gameSlug === 'string')) {
    return {
      notFound: true,
    };
  }

  if (
    params.gameSlug === 'classic-wrath' ||
    params.gameSlug === 'classic-cata'
  ) {
    return {
      redirect: {
        statusCode: 307,
        destination: '/classic-mop/builds/classes-and-specs',
      },
    };
  }

  initRequest({
    route: '/[gameSlug]/builds/classes-and-specs',
    path: `/${params.gameSlug}/builds/classes-and-specs`,
  });

  const pageViewModels = await getBuildsClassesAndSpecsPageViewModels(
    params.gameSlug,
  );

  if (!pageViewModels.buildsClassesAndSpecsPage) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      googleAnalytics: pageViewModels.googleAnalytics,
      game: pageViewModels.game,
      header: pageViewModels.header,
      footer: pageViewModels.footer,
      buildsClassesAndSpecsPage: pageViewModels.buildsClassesAndSpecsPage,
    },
    revalidate: thirteenHours,
  };
};
